if (!customElements.get('start-frame-finder')) {
    class StartFrameFinder extends HTMLElement {
        connectedCallback() {
            this.addEventListener('click', () => this.resetAndGoToNextSection());
        }

        resetAndGoToNextSection() {
            const currentSection = this.closest('frame-finder-main');
            if (currentSection) {
                currentSection.style.display = 'none';
                currentSection.classList.remove('active');
            }

            // Vai alla sezione successiva
            const nextIndex = parseInt(currentSection.getAttribute('data-index')) + 1;
            const nextSection = document.querySelector(`frame-finder-main[data-index="${nextIndex}"]`);

            if (nextSection) {
                nextSection.style.display = 'block';
                nextSection.classList.add('active');
                
                // Controllo se ci sono opzioni selezionate nella nuova sezione
                this.checkInitialSelections(nextSection);
            }
        }

        checkInitialSelections(section) {
            const selectedOptions = section.querySelectorAll('input[type="radio"]:checked, input[type="checkbox"]:checked');
            const nextButtons = section.querySelectorAll('.next-button, .button-arrow');

            nextButtons.forEach(nextButton => {
                nextButton.disabled = selectedOptions.length === 0;
            });
        }
    }

    customElements.define('start-frame-finder', StartFrameFinder);
}